import { render, staticRenderFns } from "./painel-orquestrador.vue?vue&type=template&id=64dd5828&scoped=true&"
import script from "./painel-orquestrador.vue?vue&type=script&lang=js&"
export * from "./painel-orquestrador.vue?vue&type=script&lang=js&"
import style0 from "./painel-orquestrador.vue?vue&type=style&index=0&id=64dd5828&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd5828",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64dd5828')) {
      api.createRecord('64dd5828', component.options)
    } else {
      api.reload('64dd5828', component.options)
    }
    module.hot.accept("./painel-orquestrador.vue?vue&type=template&id=64dd5828&scoped=true&", function () {
      api.rerender('64dd5828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/painel-orquestrador/painel-orquestrador.vue"
export default component.exports